<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">page_0041_master_system_detail</div>
        <app-header>esma</app-header>
        <div :class="'container ' + pageContainerSize">
          <title-and-slot title="メール作成(送信先ユーザ)" >
            <div>
            </div>
          </title-and-slot>
          <div class="row" style="margin-bottom:10px;">
            <div class="col-xs-12" style="margin:20px 0px;">
              <master-user
              :searchData="selectedUserIDs"
              @selected="onSelectedUserSelected"
              :showSearch="false"
              :showDetailsButtons="false"
              :allUserIds="false"
              :showCheckBox="true"
              subSearchMode="only"
              refreshTag="selectedUsersRefresh"
              tabStyle="width: 100%; height: 200px"
              />
            </div>
            <div class="col-xs-12" style="">
              <div class="" style="" >
                  <button class="btn btn-success" style="min-width:100px;float:left;margin-left: 15px;margin-right:5px;" @click="addUser" >▲ユーザ追加</button>
                  <button class="btn btn-info" style="min-width:100px;float:left;margin-left: 15px;margin-right:5px;"  @click="removeUsers">ユーザ選択解除</button>
              </div>
            </div>
            <div class="col-xs-12" style="margin:20px 0px;">
              <master-user
              @selected="onNewUserSelected"
              :showSearch="true"
              :allUserIds="true"
              sourceState="2"
              :searchData="selectedUserIDs"
              subSearchMode="ignore"
              refreshTag="allUsersRefresh"
              :showDetailsButtons="false"
              :showCheckBox="true"
              tabStyle="width: 100%; height: 200px"
              />
            </div>
            <div class="col-xs-12" style="">
              <div class="" style="margin-bottom:10px;" >
                  <button class="btn btn-primary" style="min-width:100px;margin-left: 15px;float: left;" @click="backToList" >＜　戻る</button>
              </div>
            </div>
          </div>
      </div>
      <!-- <confirmation-modal tag="deleteMailMessageUsersModal" /> -->
    </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import { fields, filed_types } from '@/rules/fields_mail_message';
import { utils } from '@/libs/utils';
import _debug from 'debug';
var mdebug = _debug('esma:mail_message');
import fieldBoxes from '@/components/form-field';
import masterUser from '@/components/sub_pages/master_user';
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import { bus } from '@/libs/bus';
import Master_user from '../components/sub_pages/master_user.vue';
export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    'field-box': fieldBoxes,
    'master-user':masterUser
  },
  data() {
    return {
      api_name:"mail_message",
      page_acl: acl.master,
      loading:true,
      local_new_user_selected :[],
      local_selected_user_selected :[],
      selected_user_ids :[-1]
    };
  },
  computed: {
    selectedUserIDs:{
      get(){
        return this.selected_user_ids;
      },
      set(v){
        if(Array.isArray(v) == false || v.length == 0){
          v = [-1]
        }
        this.selected_user_ids = v;
      }
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    formFields() {
      return {
        col1:[
          utils.extend(_.clone(fields.mail_subject), {label_class:"col-xs-2 control-label esma_form_label",field_class:"col-xs-10",label:"件名"}),
          utils.extend(_.clone(fields.mail_content), {label:"本文"}),
        ],
      }
    }
  },
  methods: {
    addUser(){
      var temp = this.selectedUserIDs || [-1];
      this.local_new_user_selected.forEach(n => {
        if(temp.indexOf(n) <0){
          temp.push(n)
        }
      });
      this.selectedUserIDs = temp;
      window.sessionStorage.setItem("send_mail_destination",JSON.stringify(this.selectedUserIDs))
      bus.$emit("selectedUsersRefresh",this.selectedUserIDs)
      bus.$emit("allUsersRefresh",this.selectedUserIDs)
    },
    removeUsers(){
      var temp = this.selectedUserIDs || [-1];
      var temp2 = _.remove(temp,(r=>{ return this.local_selected_user_selected.indexOf(r) < 0}))
      this.selectedUserIDs = temp2;
      if(this.selectedUserIDs.length == 0){
        this.selectedUserIDs = [-1]
      }
      window.sessionStorage.setItem("send_mail_destination",JSON.stringify(this.selectedUserIDs))
      bus.$emit("selectedUsersRefresh",this.selectedUserIDs)
      bus.$emit("allUsersRefresh",this.selectedUserIDs)
    },
    onSelectedUserSelected(list){
      this.local_selected_user_selected = list;
    },
    onNewUserSelected(list){
      this.local_new_user_selected = list;
    },
    backToList(){
      return this.$router.push({ name: "page_0081_mail_message_create", params: {seq_id:this.$route.params.seq_id}  });
    }
  },
  mounted() {
    var temp = window.sessionStorage.getItem("send_mail_destination");
    if(temp && temp.length > 1){
      temp = JSON.parse(temp)
    }
    if(typeof temp == "undefined" || !temp || temp== ""|| Array.isArray(temp) == false){
      temp = [-1];
    }
    window.sessionStorage.setItem("send_mail_destination",JSON.stringify(temp))
    this.selectedUserIDs = temp;
    if(temp.length > 0){
      bus.$emit("selectedUsersRefresh",this.selectedUserIDs)
      bus.$emit("allUsersRefresh",this.selectedUserIDs)
    }
  },
  beforeDestroy() {
  },
  beforeMount() {
  }
};

</script>
<style scoped>

input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>


// WEBPACK FOOTER //
// page_0081_mail_message_users.vue?49eee58c